import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[cvPreventMenuClose]'
})
export class PreventMenuCloseDirective {

    constructor(
        public element: ElementRef<HTMLElement>,
    ) { }

}
